"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Tabs = _ref => {
  let {
    children,
    defaultKey,
    id,
    onSelect
  } = _ref;
  const [key, setKey] = (0, _react.useState)(defaultKey);
  const tabContentArray = [],
    dropdownChildren = [],
    titles = {};
  const defaultTitle = 'Select Tab';
  _react.default.Children.forEach(children, child => {
    titles[child.props.eventKey] = child.props.title;
  });
  const [title, setTitle] = (0, _react.useState)(titles[defaultKey] || defaultTitle);
  const onSelectTab = (eventKey, event) => {
    setKey(eventKey);
    setTitle(titles[eventKey]);
    if (onSelect) onSelect(eventKey, event);
  };
  _react.default.Children.forEach(children, (child, idx) => {
    tabContentArray.push( /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab.Pane, {
      key: `${child.props.eventKey}-${idx}`,
      eventKey: child.props.eventKey
    }, child.props.children));
    dropdownChildren.push( /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
      onSelect: onSelectTab,
      bsPrefix: "dropdown-item nav-link",
      key: `${child.props.eventKey}-${idx}`,
      eventKey: child.props.eventKey
    }, child.props.title));
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-tabnav"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown, {
    onSelect: setKey
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Toggle, {
    variant: "secondary",
    id: "dropdown-basic"
  }, title), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Menu, null, dropdownChildren))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab.Container, {
    id: id ? id : 'massmutual-tab-nav',
    defaultActiveKey: key,
    activeKey: key,
    onSelect: onSelectTab
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav, {
    variant: "tabs",
    defaultActiveKey: key,
    activeKey: key,
    onSelect: setKey,
    as: "ul"
  }, children), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab.Content, null, tabContentArray)));
};
const Tab = _ref2 => {
  let {
    title,
    titleContent,
    ...props
  } = _ref2;
  const content = titleContent ? titleContent : title;
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav.Item, {
    as: "li",
    role: "presentation"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Nav.Link, _extends({
    title: title
  }, props), content));
};
Tab.propTypes = {
  title: _propTypes.default.string,
  titleContent: _propTypes.default.node
};
Tabs.Tab = Tab;
Tabs.TabContainer = _reactBootstrap.Tabs.TabContainer;
Tabs.TabContent = _reactBootstrap.Tabs.TabContent;
Tabs.TabPane = _reactBootstrap.Tabs.TabPane;
Tabs.propTypes = {
  /**
   * The content of the Tabs component.
   */
  children: _propTypes.default.node.isRequired,
  /** The key of the tab you like selected by default when the tabs render. Can be used to update which tab the active tab */
  defaultKey: _propTypes.default.string,
  /**  the id string appended to the ids of all of the individual tab ids */
  id: _propTypes.default.string,
  /** A handler invoked when a tab is selected. */
  onSelect: _propTypes.default.func
};
var _default = exports.default = Tabs;